function makeid(length: Number) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

class UploadSuccess {
  private _id: string;

  get id() {
      return this._id;
  }

  constructor(id: string) {
    this._id = id;
  }
}

class UploadError {
    private _error: string;
  
    get error() {
        return this._error;
    }
  
    constructor(error: string) {
      this._error = error;
    }
  }

class Test {
  private test: Array<Number>;
}

async function upload(file: File, with_face: boolean, collage: boolean, is_new: boolean): Promise<UploadSuccess | UploadError> {
  const formData = new FormData();
  formData.append("id", "11111-" + makeid(6));
  formData.append("image", file);
  formData.append("wm", "3");

  if (is_new)
  {
    formData.append("type", "5836113")
  } else if (Math.random() < 0.5) {
    formData.append("type", "1");
  } else {
    formData.append("type", "0");
  }

  if (collage && !is_new) {
    formData.append("collage", "1");
  }

  if (with_face === false) {
    formData.append("no_crop", "1")
  }

  // let ask = await fetch("https://portraitplus.facefun.ai/Port/MakePort", {
  //   method: "POST",
  //   body: formData, // This is your file object
  // });


  try {
    const response = await fetch("https://portraitplus.facefun.ai/Port/MakePortBulk", {
      method: "POST",
      body: formData,
    });

    const ans = await response.json();
    const text = ans.files[0];

    if (typeof text === "string" && text.endsWith(".jpg")) {
      return new UploadSuccess(text);
    } else {
      return new UploadError(text);
    }

  } catch (error) {
    return new UploadError("Connection error");
  }
}


export { upload, UploadSuccess, UploadError };
